<template>
  <div class="container-lg">
    <div class="index-content">
      <a :href="link.link" class="index-content-item" :class="{'last': total == index+1 }" v-for="(link, index) in links">
        <div class="ici-title">
          <div v-html="link.title"></div>
          <div class="ici-img" >
            <img :src="link.image" alt="">
          </div>
        </div>
        <div class="ici-link">
          <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="42" height="42" rx="21" fill="#E8E8E8"/>
            <path d="M14.0048 15.6663C14.0048 15.9756 14.1276 16.2722 14.3464 16.4909C14.5651 16.7097 14.8617 16.8325 15.171 16.8325H24.023L14.343 26.5009C14.1234 26.7205 14 27.0184 14 27.329C14 27.6395 14.1234 27.9374 14.343 28.157C14.5626 28.3766 14.8605 28.5 15.171 28.5C15.4816 28.5 15.7795 28.3766 15.9991 28.157L25.6675 18.477V27.329C25.6675 27.6383 25.7903 27.9349 26.0091 28.1536C26.2278 28.3724 26.5244 28.4952 26.8337 28.4952C27.143 28.4952 27.4397 28.3724 27.6584 28.1536C27.8771 27.9349 28 27.6383 28 27.329V15.6663C27.9982 15.5139 27.9665 15.3633 27.9067 15.2231C27.7884 14.9381 27.5619 14.7116 27.2769 14.5933C27.1367 14.5335 26.9861 14.5018 26.8337 14.5H15.171C14.8617 14.5 14.5651 14.6229 14.3464 14.8416C14.1276 15.0603 14.0048 15.357 14.0048 15.6663Z"
                  fill="#676767"/>
          </svg>
        </div>
      </a>
      <a href="#" data-link-alt="Показать еще" @click.prevent="loadData" v-if="links.length < total" class="ic-load-more slice-hover">
        <span class="sh-native">Показать еще</span>
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 3.5C15.4477 3.5 15 3.94772 15 4.5C15 5.05228 15.4477 5.5 16 5.5C18.9174 5.5 21.7153 6.65893 23.7782 8.72183C25.8411 10.7847 27 13.5826 27 16.5C27 19.4174 25.8411 22.2153 23.7782 24.2782C21.7153 26.3411 18.9174 27.5 16 27.5C15.4477 27.5 15 27.9477 15 28.5C15 29.0523 15.4477 29.5 16 29.5C19.4478 29.5 22.7544 28.1304 25.1924 25.6924C27.6304 23.2544 29 19.9478 29 16.5C29 13.0522 27.6304 9.74558 25.1924 7.30761C22.7544 4.86964 19.4478 3.5 16 3.5Z" fill="#333333" fill-opacity="0.6"/>
          <path d="M5 16.4981C5.00009 15.9458 4.55245 15.4981 4.00016 15.498C3.44788 15.4979 3.00009 15.9455 3 16.4978C2.99957 19.166 3.82018 21.7697 5.35042 23.9555C6.88067 26.1413 9.04644 27.8033 11.5537 28.7159C12.0727 28.9048 12.6466 28.6372 12.8355 28.1182C13.0243 27.5993 12.7568 27.0254 12.2378 26.8365C10.1162 26.0643 8.28365 24.658 6.98882 22.8085C5.694 20.959 4.99964 18.7558 5 16.4981Z" fill="#333333" fill-opacity="0.6"/>
          <path d="M8.25418 7.28048C8.64334 7.67236 8.64112 8.30552 8.24924 8.69468C7.10029 9.83563 6.2174 11.2162 5.6636 12.7378C5.4747 13.2568 4.90086 13.5243 4.38188 13.3354C3.86291 13.1466 3.59532 12.5727 3.78421 12.0537C4.43871 10.2555 5.48212 8.62394 6.83997 7.27554C7.23186 6.88638 7.86502 6.88859 8.25418 7.28048Z" fill="#333333" fill-opacity="0.6"/>
          <path d="M12.2454 6.16079C12.7645 5.97226 13.0325 5.3986 12.844 4.87949C12.6554 4.36038 12.0818 4.09239 11.5627 4.28092C11.2043 4.41107 10.8519 4.55691 10.5064 4.71803C10.0058 4.95143 9.78924 5.54641 10.0227 6.04695C10.2561 6.54749 10.8511 6.76405 11.3516 6.53064C11.644 6.39431 11.9422 6.27091 12.2454 6.16079Z" fill="#333333" fill-opacity="0.6"/>
        </svg>

      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "index-links",

  data() {
    return {
      links: [],
      total: 0
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.axios.get('/getIndexLinks?offset='+this.links.length).then((response)=>{
        let keys = Object.keys(response.data.links);
        this.total = response.data.total
        keys.forEach((key)=>{
          this.links.push(response.data.links[key]);
        });
      })
    },

  },
}
</script>
